import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getIsMobile } from 'src/store/view/selectors';
import { getReviewsLT } from 'src/store/reviews/selectors';
import Rating from '../../components/Rating';
import {
  isRating,
  getRatingsList,
  getRatingsScore,
  getRatingsScoreDescription,
  getRatingsCount,
  getGoodToKnowList,
  getRatingText,
} from '../../store/selectors/rating';

const RatingBlock = ({
  isRatingExist,
  ratingList,
  showReviewsButton,
  isMobile,
  ...props
}) =>
  isRatingExist &&
  ratingList.length > 0 && (
    <Rating
      category={ratingList}
      showReviewsButton={showReviewsButton}
      isMobile={isMobile}
      {...props}
    />
  );

RatingBlock.propTypes = {
  isRatingExist: PropTypes.bool.isRequired,
  ratingList: PropTypes.arrayOf(
    PropTypes.shape({
      category_name: PropTypes.string.isRequired,
      category_id: PropTypes.string.isRequired,
      score: PropTypes.number.isRequired,
    }),
  ),
};

RatingBlock.defaultProps = {
  ratingList: null,
};

const mapStateToProps = (state) => ({
  isRatingExist: isRating(state),
  ratingList: getRatingsList(state),
  goodToKnowList: getGoodToKnowList(state),
  score: getRatingsScore(state),
  scoreDescription: getRatingsScoreDescription(state),
  count: getRatingsCount(state),
  showReviewsButton: getReviewsLT(state).length === 0,
  isMobile: getIsMobile(state),
  text: getRatingText(state),
});

export default connect(mapStateToProps)(RatingBlock);
